module.exports = __webpack_public_path__ + "static/media/Nguyen-Duc-Dat.2c148927.jpg";